import { render } from "./NoahAiHome.vue?vue&type=template&id=5099052a&scoped=true"
import script from "./NoahAiHome.vue?vue&type=script&lang=js"
export * from "./NoahAiHome.vue?vue&type=script&lang=js"

import "./NoahAiHome.vue?vue&type=style&index=0&id=5099052a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5099052a"]])

export default __exports__